/* eslint-disable */
export const initSeledted = () => {
	const handleSelectedMethod = () => {
		const cards = document.querySelectorAll(".payment-card");

		if (!cards || cards.length === 0) return;

		// function to mark a card as default
		const setDefault = (targetCard) => {
			cards.forEach((c) => {
				// reset visual state
				c.classList.remove("bg-primary-50", "border-primary-50");
				c.classList.add("bg-white", "border-gray-100");
				c.dataset.default = "false";

				const action = c.querySelector(".action-default");
				if (action) {
					// replace action content with a Set Default button
					action.innerHTML = `
						<button class="btn-set-default px-3 h-8 text-xs text-gray-900 font-medium cursor-pointer">${wpcore.direct_t({ en: 'Set Default', fr: 'Définir par défaut' })}</button>
					`;
					const newBtn = action.querySelector(".btn-set-default");
					if (newBtn) {
						newBtn.addEventListener("click", () => setDefault(c));
					}
				}
			});

			// mark the chosen card as default
			targetCard.classList.remove("bg-white", "border-gray-100");
			targetCard.classList.add("bg-primary-50", "border-primary-50");
			targetCard.dataset.default = "true";

			const action = targetCard.querySelector(".action-default");
			if (action) {
				action.innerHTML = `
					<div class="flex items-center gap-2 px-3 py-1 bg-primary-500 rounded-full">
						<span class="fi fi-sr-check text-xs text-white"></span>
						<p class="text-xs font-medium text-white mb-0 ">${wpcore.direct_t({ en: 'Default', fr: 'Par défaut' })}</p>
					</div>
				`;
			}
		};

		cards.forEach((card) => {
			const btn = card.querySelector(".btn-set-default");

			if (!btn) return;

			btn.addEventListener("click", () => setDefault(card));
		});
	};

	const handleSelectedBiling = () => {
		const container = document.querySelectorAll(".billing-item");

		if (container.length < 0) return;

		container.forEach((c) => {
			const radio = c.querySelector('input[name="biling-method"]');

			if (!radio) return;

			if (radio.checked) {
				c.classList.remove("border-gray-100");
				c.classList.add("bg-primary-50", "border-primary-50");
			} else {
				c.classList.add("border-gray-100");
				c.classList.remove("bg-primary-50", "border-primary-50");
			}

			radio.addEventListener("change", () => {
				// reset tất cả radio trước
				container.forEach((item) => {
					item.classList.add("border-gray-100");
					item.classList.remove("bg-primary-50", "border-primary-50");
				});

				// highlight radio vừa chọn
				if (radio.checked) {
					c.classList.remove("border-gray-100");
					c.classList.add("bg-primary-50", "border-primary-50");
				}
			});
		});
	};

	// init
	handleSelectedMethod();
	handleSelectedBiling();
};
